import { useGlobalSiteHeaderContext } from '@components/GlobalSiteHeader/GlobalSiteHeaderContext';
import { useSnackbar } from '@components/Snackbar';
import auth from '@util/api/auth';
import { useEffect, useState } from 'react';

type RefreshPropertiesCallback = ({
  listingId,
  listOfficeMlsId,
  remove,
}: {
  listingId: string;
  listOfficeMlsId: string;
  remove: boolean;
}) => void;

interface UsePropertySaverReturn {
  isFav: boolean | null;
  onSaveProperty: (refreshProperties?: RefreshPropertiesCallback) => void;
}

interface UsePropertSaverArgs {
  listingId: string;
  listOfficeMlsId: string;
}

const usePropertySaver = ({
  listingId,
  listOfficeMlsId,
}: UsePropertSaverArgs): UsePropertySaverReturn => {
  const { toSetModalSection, isListingFavorited, saveListing, deleteSavedListing } =
    useGlobalSiteHeaderContext();
  const [isFav, setIsFav] = useState<boolean>(isListingFavorited(listingId, listOfficeMlsId));
  const { showSnackbar } = useSnackbar();

  useEffect(() => {
    const isFav = isListingFavorited(listingId, listOfficeMlsId);
    setIsFav(isFav);
  }, [isListingFavorited, listingId]);

  const onSaveProperty = async (refreshProperties?: RefreshPropertiesCallback) => {
    try {
      const userData = await auth.getUser();
      if (userData?.attributes?.sub && listingId && listOfficeMlsId) {
        if (isFav) {
          if (refreshProperties) {
            refreshProperties({ listingId, listOfficeMlsId, remove: true });
          }
          setIsFav(false);
          await deleteSavedListing(userData?.attributes?.sub, listingId);
          showSnackbar('Property unsaved successfully!');
        } else {
          setIsFav(true);
          await saveListing(userData?.attributes?.sub, listingId, listOfficeMlsId);
          showSnackbar('Property saved successfully!');
        }
      } else {
        toSetModalSection('accountIntro');
      }
    } catch (err) {
      console.error(err);
      // Revert back to the previous state
      setIsFav(isFav);

      if (refreshProperties) {
        refreshProperties({ listingId, listOfficeMlsId, remove: false });
      }
      // toSetModalSection('accountIntro');
    }
  };

  return {
    isFav,
    onSaveProperty,
  };
};

export default usePropertySaver;
